import { Ng2StateDeclaration } from '@uirouter/angular';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import { AdminScanExclusionsComponent } from '@client/app/feature-modules/admin/modules/admin-scan-exclusions/components/admin-scan-exclusions/admin-scan-exclusions.component';
import { AdminScanExclusionsFormComponent } from '../components/admin-scan-exclusions-form/admin-scan-exclusions-form.component';
import { Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Injectable({ providedIn: 'root' })
export class ScanExclusionsAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('admin_source_code_excludes')) {
            return true;
        }
        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}

const scanExclusionsAccessResolve = [
    {
        token: 'scanExclusionsAccess',
        deps: [ScanExclusionsAccessGuard, Transition],
        resolveFn: (guard: ScanExclusionsAccessGuard, transition: Transition) =>
            guard.checkAccess(transition),
    },
];

export const AdminScanExclusionsStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.scan-exclusions',
        url: '/scan-exclusions?page_size&page&module',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
            module: {
                dynamic: true,
                value: 'accessibility',
            },
        },
        redirectTo: paginationUrlQueryParamsValidator('base.customer.admin.scan-exclusions'),
        resolve: scanExclusionsAccessResolve,
        component: AdminScanExclusionsComponent,
        data: { title: 'Acquia Web Governance - Scan Exclusions' },
    },
    {
        name: 'base.customer.admin.add-scan-exclusions',
        url: '/scan-exclusions-form',
        resolve: scanExclusionsAccessResolve,
        component: AdminScanExclusionsFormComponent,
        data: { title: 'Acquia Web Governance - Add Scan Exclusions' },
    },
    {
        name: 'base.customer.admin.edit-scan-exclusions',
        url: '/scan-exclusions-form/:id/:module',
        resolve: scanExclusionsAccessResolve,
        component: AdminScanExclusionsFormComponent,
        data: { title: 'Acquia Web Governance - Edit Scan Exclusions' },
    },
];
